<ng-template #showGiviNoteModal let-modal>
    <div class="modal-body">
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="d-flex justify-content-center mt-3">
            <p class="main-text text-center">Editar nota</p>
        </div>
        <div class="d-flex text-center mt-1">
            <p class="second-text mb-3">Agregá una nota para llevar control de tus regalos.</p>
        </div>
        <div class="d-flex text-center">
            <textarea [(ngModel)]="note" maxlength="50" class="form-control mb-4" rows="2" placeholder="Agregá una nota aquí"></textarea>
        </div>
        <div class="d-flex text-left mb-2">
            <label class="label-color">Color:</label>
        </div>
        <div class="d-flex mb-5 justify-content-center">
            <div class="mr-3 color-1" [ngClass]="{'select-color' : selectColor == '#753CFD'}" (click)="changeColor('#753CFD')"></div>
            <div class="mr-3 color-2" [ngClass]="{'select-color' : selectColor == '#01E68C'}" (click)="changeColor('#01E68C')"></div>
            <div class="mr-3 color-3" [ngClass]="{'select-color' : selectColor == '#FE574E'}" (click)="changeColor('#FE574E')"></div>
            <div class="mr-3 color-4" [ngClass]="{'select-color' : selectColor == '#73CDFF'}" (click)="changeColor('#73CDFF')"></div>
            <div class="mr-3 color-5" [ngClass]="{'select-color' : selectColor == '#FED800'}" (click)="changeColor('#FED800')"></div>
        </div>
        <div class="d-flex-center w-100">
            <div class="pr-2">
                <button class="btn btn-outline-primary btn-wsm" (click)="closeModal()">Salir</button>
            </div>
            <div>
                <button class="btn btn-primary btn-wsm" (click)="saveNote()">Guardar</button>
            </div>
        </div>
    </div>
</ng-template>
